import { ANALYSIS_FAMILIES, MEDICAL_COVERAGE_TYPES } from '../../../constants/medicalExamCategories';

const COVERAGE_SHORT_LABEL = {
  [MEDICAL_COVERAGE_TYPES.SMIE.id]: 'SMIE',
  [MEDICAL_COVERAGE_TYPES.CMC.id]: 'CMC'
};

export function getExamCoveragePillProps(coverageType) {
  const isCmc = coverageType === MEDICAL_COVERAGE_TYPES.CMC.id;
  return {
    label: COVERAGE_SHORT_LABEL[coverageType] || coverageType,
    className: `hd-exam-coverage-pill hd-exam-list__coverage hd-exam-coverage-pill--${
      isCmc ? 'cmc' : 'smie'
    }`
  };
}

/**
 * Ligne secondaire : métadonnées hors couverture (SMIE/CMC toujours affichée sur la ligne).
 */
export function buildExamListSecondaryLine(item, { categoryConfig, isAnalysis, selectedAnalysisFamily }) {
  const parts = [];

  if (isAnalysis && item.analysis_family && !selectedAnalysisFamily) {
    parts.push(ANALYSIS_FAMILIES[item.analysis_family]?.label || item.analysis_family);
  }

  if (categoryConfig?.metadataFields) {
    categoryConfig.metadataFields.forEach((field) => {
      const value = item.metadata?.[field.key];
      if (field.type === 'boolean') {
        if (value) parts.push(field.label);
        return;
      }
      if (value) parts.push(String(value));
    });
  }

  if (item.description?.trim()) {
    parts.push(item.description.trim());
  }

  return parts.join(' · ');
}
